import styled from 'styled-components';

export const Underline = styled.span`
  display: inline-block;
  width: 85%;
  margin: 0 0 2rem 0.5rem;
  border-bottom: 2px solid #dcdcdc;
`;
